import React from 'react';
import '../../../App.css';
import './SkinBuilder.css';
import { get } from "../network/Resources";
import { buildApk } from "../network/SkinBuilder";
import { withCookies } from "react-cookie";
import { Card, Message, Modal, Input, Rule, Form, Select, Grid, Tabs, Button } from 'shineout'
import ReactJson from "react-json-view";
import { MdColorLens, MdTv, MdBolt, MdPhoneAndroid, MdPermMedia, MdImage, MdInbox, MdFileDownload, MdDescription } from "react-icons/md";

const rules = Rule();

const ABOUT_US_NAMES = ["about_us.webp", "about_us_ctv_lite.webp", "thunder_about_us.webp"];
const BRAND_LOGO_NAMES = ["brand_logo.webp", "thunder_brand_logo.webp"];
const RAM_OPTIONS = ["512MB", "1GB"];
// The build script only understands a 512M ("lite") or 1G ("normal") tier.
const RAM_VALUE_MAP = { "512MB": "512M", "1GB": "1G" };

// buildDate from the script is a plain YYYYMMDDHHMMSS string.
function formatBuildDate(raw) {
    if (!raw || raw.length !== 14) return raw;
    return raw.slice(0, 4) + '-' + raw.slice(4, 6) + '-' + raw.slice(6, 8) + ' '
        + raw.slice(8, 10) + ':' + raw.slice(10, 12) + ':' + raw.slice(12, 14);
}

function formatSize(raw) {
    var bytes = parseInt(raw, 10);
    if (isNaN(bytes)) return raw;
    return bytes.toLocaleString() + ' bytes (' + (bytes / (1024 * 1024)).toFixed(2) + ' MB)';
}

class SkinBuilder extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            brand: [],
            vendor: [],
            factory: [],
            activeTab: 'normal',
            generatedJson: undefined,
            buildInfo: null,
            normalAboutUsFile: null,
            normalBrandLogoFile: null,
            thunderAboutUsFile: null,
            thunderBrandLogoFile: null,
            normalAboutUsFilePreview: null,
            normalBrandLogoFilePreview: null,
            thunderAboutUsFilePreview: null,
            thunderBrandLogoFilePreview: null,
            normalTermMode: 'text',
            thunderTermMode: 'text',
            normalTermFile: null,
            thunderTermFile: null,
            formResetKey: 0,
            building: false,
        }
    };

    componentWillMount() {
        get({ type: 'brand' }, (data) => {
            this.setState({ brand: data.map(e => e.name) });
        });
        get({ type: 'vendor' }, (data) => {
            this.setState({ vendor: data.map(e => e.name) });
        });
        get({ type: 'factory' }, (data) => {
            this.setState({ factory: data.map(e => e.name) });
        });
    }

    componentWillUnmount() {
        ['normalAboutUsFilePreview', 'normalBrandLogoFilePreview', 'thunderAboutUsFilePreview', 'thunderBrandLogoFilePreview']
            .forEach(key => { if (this.state[key]) URL.revokeObjectURL(this.state[key]); });
    }

    handleImageFile = (stateKey, label, allowedNames) => (e) => {
        var file = e.target.files && e.target.files[0];
        if (!file) return;
        if (allowedNames.indexOf(file.name) === -1) {
            Message.error(label + ' file name must be one of: ' + allowedNames.join(', '), 5, { position: 'bottom-right' });
            e.target.value = '';
            return;
        }
        var previewKey = stateKey + 'Preview';
        var previewUrl = URL.createObjectURL(file);
        var oldPreviewUrl = this.state[previewKey];
        if (oldPreviewUrl) URL.revokeObjectURL(oldPreviewUrl);
        this.setState({ [stateKey]: file, [previewKey]: previewUrl });
    };

    handleTermModeChange = (prefix, mode) => () => {
        this.setState({ [prefix + 'TermMode']: mode });
    };

    handleTermHtmlFile = (prefix) => (e) => {
        var file = e.target.files && e.target.files[0];
        if (!file) return;
        if (!/\.html?$/i.test(file.name)) {
            Message.error('Term & Condition file must be an .html file', 3, { position: 'bottom-right' });
            e.target.value = '';
            return;
        }
        this.setState({ [prefix + 'TermFile']: file });
    };

    makeSkin = (skinType) => (value) => {
        var brandLogoFile = skinType === 'normal' ? this.state.normalBrandLogoFile : this.state.thunderBrandLogoFile;
        var aboutUsFile = skinType === 'normal' ? this.state.normalAboutUsFile : this.state.thunderAboutUsFile;
        var termMode = this.state[skinType + 'TermMode'];
        var termFile = this.state[skinType + 'TermFile'];
        // Brand Logo and About Us are both optional now — the script just leaves the sample
        // apk's existing assets in place when either is omitted.
        if (termMode === 'file' && !termFile) {
            Message.error('Please choose an HTML file for Term & Condition', 3, { position: 'bottom-right' });
            return;
        }
        if (termMode === 'text' && !value.term_condition) {
            Message.error('Please enter Term & Condition text', 3, { position: 'bottom-right' });
            return;
        }
        var termValue = termMode === 'file' ? termFile.name : value.term_condition;
        var json = {
            skinType: skinType,
            brand: value.brand,
            vendor: value.vendor,
            factory: value.factory,
            ram: RAM_VALUE_MAP[value.ram] || value.ram,
            // Validation: true only when a brand logo was actually supplied, false otherwise.
            // Not a manual toggle — derived straight from whether the logo file is present.
            brandLogoVisible: !!brandLogoFile,
        };
        // Thunder gets its own key names to keep the two skin schemas distinguishable downstream.
        if (skinType === 'normal') {
            if (brandLogoFile) json.brand_logo = brandLogoFile.name;
            if (aboutUsFile) json.about_us = aboutUsFile.name;
            json.term_condition = termValue;
        } else {
            if (brandLogoFile) json.thunder_brand_logo = brandLogoFile.name;
            if (aboutUsFile) json.thunder_about_us = aboutUsFile.name;
            json.thunder_term_condition = termValue;
        }
        this.setState({ generatedJson: json, buildInfo: null });
        Message.success('Skin JSON generated', 3, { position: 'bottom-right' });
    };

    resetAll = () => {
        ['normalAboutUsFilePreview', 'normalBrandLogoFilePreview', 'thunderAboutUsFilePreview', 'thunderBrandLogoFilePreview']
            .forEach(key => { if (this.state[key]) URL.revokeObjectURL(this.state[key]); });
        // Bumping formResetKey remounts the Forms, which clears their internal
        // (uncontrolled) field values too. generatedJson/buildInfo are left alone so the
        // just-built result (and its Download button) stay visible until the next "Make Skin".
        this.setState(prevState => ({
            normalAboutUsFile: null,
            normalBrandLogoFile: null,
            thunderAboutUsFile: null,
            thunderBrandLogoFile: null,
            normalAboutUsFilePreview: null,
            normalBrandLogoFilePreview: null,
            thunderAboutUsFilePreview: null,
            thunderBrandLogoFilePreview: null,
            normalTermMode: 'text',
            thunderTermMode: 'text',
            normalTermFile: null,
            thunderTermFile: null,
            formResetKey: prevState.formResetKey + 1,
        }));
    };

    confirmAndDownload = () => {
        var json = this.state.generatedJson;
        var skinType = json.skinType;
        var termMode = this.state[skinType + 'TermMode'];
        var termFile = this.state[skinType + 'TermFile'];
        var termText = skinType === 'normal' ? json.term_condition : json.thunder_term_condition;
        Modal.confirm({
            title: 'Confirm skin configuration',
            content: (
                <div>
                    <p>Build and sign the APK for <b>{json.brand}</b> (vendor: {json.vendor}, factory: {json.factory}, ram: {json.ram})?</p>
                    <p style={{ color: '#64748b', fontSize: 13 }}>
                        Brand logo and about us image are optional &mdash; brandLogoVisible is set to {json.brandLogoVisible ? 'true' : 'false'} automatically
                        based on whether a logo was provided. Ram and Term &amp; Condition (text or html file) are used by the
                        build script. This runs a real decompile/sign pipeline and can take up to a minute; keep this page open.
                    </p>
                </div>
            ),
            text: { ok: 'Build APK', cancel: 'Cancel' },
            onOk: () => this.downloadApk(skinType, termMode === 'file' ? null : termText, termMode === 'file' ? termFile : null),
        });
    };

    downloadApk = (skinType, termText, termHtmlFile) => {
        var json = this.state.generatedJson;
        var brandLogoFile = skinType === 'normal' ? this.state.normalBrandLogoFile : this.state.thunderBrandLogoFile;
        var aboutUsFile = skinType === 'normal' ? this.state.normalAboutUsFile : this.state.thunderAboutUsFile;
        this.setState({ building: true });
        buildApk({
            brand: json.brand,
            vendor: json.vendor,
            factory: json.factory,
            ram: json.ram,
            term_condition: termText,
            brand_logo: brandLogoFile,
            about_us: aboutUsFile,
            term_condition_html: termHtmlFile,
        }, (result) => {
            this.setState({ building: false });
            if (!result.ok) {
                Message.error(result.message || 'Failed to build APK. Try again', 4, { position: 'bottom-right' });
                return;
            }
            var url = window.URL.createObjectURL(result.blob);
            var link = document.createElement('a');
            link.href = url;
            link.download = result.filename;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
            Message.success('APK downloaded', 3, { position: 'bottom-right' });

            this.setState({ buildInfo: result.buildInfo || {} });
            // Clears the picked files/form fields for the next skin, but leaves generatedJson
            // (and buildInfo, just set above) alone so the result stays visible below the button.
            this.resetAll();
        });
    };

    renderCommonFields() {
        return (
            <React.Fragment>
                <Grid width={0.5}>
                    <Form.Item required label="Brand">
                        <Select
                            name="brand"
                            data={this.state.brand}
                            rules={[rules.required, rules.isExist]}
                            clearable
                            keygen
                            optionWidth={320}
                            onFilter={text => d => ('' + d).toUpperCase().indexOf(('' + text).toUpperCase()) >= 0}
                            single />
                    </Form.Item>
                </Grid>
                <Grid width={0.5}>
                    <Form.Item required label="Vendor">
                        <Select
                            name="vendor"
                            data={this.state.vendor}
                            rules={[rules.required, rules.isExist]}
                            clearable
                            keygen
                            optionWidth={320}
                            onFilter={text => d => ('' + d).toUpperCase().indexOf(('' + text).toUpperCase()) >= 0}
                            single />
                    </Form.Item>
                </Grid>
                <Grid width={0.5}>
                    <Form.Item required label="Factory">
                        <Select
                            name="factory"
                            data={this.state.factory}
                            rules={[rules.required, rules.isExist]}
                            clearable
                            keygen
                            optionWidth={320}
                            onFilter={text => d => ('' + d).toUpperCase().indexOf(('' + text).toUpperCase()) >= 0}
                            single />
                    </Form.Item>
                </Grid>
                <Grid width={0.5}>
                    <Form.Item required label="RAM">
                        <Select
                            name="ram"
                            data={RAM_OPTIONS}
                            rules={[rules.required]}
                            keygen
                            clearable
                            single />
                    </Form.Item>
                </Grid>
            </React.Fragment>
        );
    }

    renderImageField(label, stateKey, allowedNames) {
        var file = this.state[stateKey];
        var previewUrl = this.state[stateKey + 'Preview'];
        var shortName = file ? (file.name.length > 16 ? file.name.slice(0, 16) + '…' : file.name) : 'Choose .webp file (optional)';
        return (
            <Form.Item label={label + ' (.webp, optional)'}>
                <label className="skin-builder-file-input" title={file ? file.name : 'Allowed names: ' + allowedNames.join(', ')}>
                    <input type="file" accept=".webp,image/webp" onChange={this.handleImageFile(stateKey, label, allowedNames)} />
                    {previewUrl ? (
                        <img className="skin-builder-file-preview" src={previewUrl} alt="" />
                    ) : (
                        <MdImage size={16} />
                    )}
                    <span>{shortName}</span>
                </label>
            </Form.Item>
        );
    }

    renderTermField(prefix) {
        var mode = this.state[prefix + 'TermMode'];
        var file = this.state[prefix + 'TermFile'];
        var shortName = file ? (file.name.length > 16 ? file.name.slice(0, 16) + '…' : file.name) : 'Choose HTML file';
        return (
            <Form.Item required label="Term & Condition">
                <div className="skin-builder-term-field">
                    <div className="skin-builder-term-toggle">
                        <button type="button" className={mode === 'text' ? 'active' : ''} onClick={this.handleTermModeChange(prefix, 'text')}>Text</button>
                        <button type="button" className={mode === 'file' ? 'active' : ''} onClick={this.handleTermModeChange(prefix, 'file')}>HTML file</button>
                    </div>
                    {mode === 'file' ? (
                        <label className="skin-builder-file-input" title={file ? file.name : undefined}>
                            <input type="file" accept=".html,.htm,text/html" onChange={this.handleTermHtmlFile(prefix)} />
                            <MdDescription size={16} />
                            <span>{shortName}</span>
                        </label>
                    ) : (
                        <Input name="term_condition" rules={[rules.required]} placeholder="e.g. Thunder TV" />
                    )}
                </div>
            </Form.Item>
        );
    }

    renderBrandLogoVisibleHint(brandLogoStateKey) {
        var visible = !!this.state[brandLogoStateKey];
        return (
            <Form.Item label="Brand Logo Visible">
                <div className={'skin-builder-visible-hint' + (visible ? ' on' : '')}>
                    {visible ? 'true' : 'false'}
                    <span>(auto — {visible ? 'a logo was chosen' : 'no logo chosen'})</span>
                </div>
            </Form.Item>
        );
    }

    render() {
        return (
            <div className="skin-builder">
                <div className="skin-builder-hero">
                    <div className="skin-builder-hero-icon"><MdColorLens size={26} /></div>
                    <div>
                        <h1>Skin Builder</h1>
                        <p>Compose a brand skin and package it for release</p>
                    </div>
                </div>

                <div className="skin-builder-grid">
                    <Card>
                        <Card.Body style={{ textAlign: 'left' }}>
                            <Tabs
                                active={this.state.activeTab}
                                onChange={key => this.setState({ activeTab: key })}
                                shape="line"
                                hideSplit>
                                <Tabs.Panel id="normal" tab={<span className="skin-builder-tab-label"><MdTv size={16} />Normal Skin</span>}>
                                    <Form key={'normal-' + this.state.formResetKey} onSubmit={this.makeSkin('normal')}>
                                        <div className="skin-builder-section-title"><MdPhoneAndroid size={14} />Device Targeting</div>
                                        <Grid gutter={2}>
                                            {this.renderCommonFields()}
                                        </Grid>
                                        <div className="skin-builder-section-title"><MdPermMedia size={14} />Branding &amp; Assets</div>
                                        <Grid gutter={2}>
                                            <Grid width={0.5}>
                                                {this.renderImageField('Brand Logo', 'normalBrandLogoFile', BRAND_LOGO_NAMES)}
                                            </Grid>
                                            <Grid width={0.5}>
                                                {this.renderImageField('About Us', 'normalAboutUsFile', ABOUT_US_NAMES)}
                                            </Grid>
                                            <Grid width={0.5}>
                                                {this.renderTermField('normal')}
                                            </Grid>
                                            <Grid width={0.5}>
                                                {this.renderBrandLogoVisibleHint('normalBrandLogoFile')}
                                            </Grid>
                                        </Grid>
                                        <Button type="primary" htmlType="submit" style={{ width: '100%', marginTop: 18 }}>Make Skin</Button>
                                    </Form>
                                </Tabs.Panel>
                                <Tabs.Panel id="thunder" tab={<span className="skin-builder-tab-label"><MdBolt size={16} />Thunder Skin</span>}>
                                    <Form key={'thunder-' + this.state.formResetKey} onSubmit={this.makeSkin('thunder')}>
                                        <div className="skin-builder-section-title"><MdPhoneAndroid size={14} />Device Targeting</div>
                                        <Grid gutter={2}>
                                            {this.renderCommonFields()}
                                        </Grid>
                                        <div className="skin-builder-section-title"><MdPermMedia size={14} />Branding &amp; Assets</div>
                                        <Grid gutter={2}>
                                            <Grid width={0.5}>
                                                {this.renderImageField('Brand Logo', 'thunderBrandLogoFile', BRAND_LOGO_NAMES)}
                                            </Grid>
                                            <Grid width={0.5}>
                                                {this.renderImageField('About Us', 'thunderAboutUsFile', ABOUT_US_NAMES)}
                                            </Grid>
                                            <Grid width={0.5}>
                                                {this.renderTermField('thunder')}
                                            </Grid>
                                            <Grid width={0.5}>
                                                {this.renderBrandLogoVisibleHint('thunderBrandLogoFile')}
                                            </Grid>
                                        </Grid>
                                        <Button type="primary" htmlType="submit" style={{ width: '100%', marginTop: 18 }}>Make Skin</Button>
                                    </Form>
                                </Tabs.Panel>
                            </Tabs>
                        </Card.Body>
                    </Card>

                    <div className="skin-builder-preview">
                        {this.state.generatedJson ? (
                            <div className="skin-builder-preview-card">
                                <div className="skin-builder-preview-titlebar">
                                    <span className="skin-builder-dot red" />
                                    <span className="skin-builder-dot yellow" />
                                    <span className="skin-builder-dot green" />
                                    <span className="skin-builder-preview-label">skin.json</span>
                                </div>
                                <div className="skin-builder-preview-json">
                                    <ReactJson
                                        autosize
                                        fullWidth
                                        theme="monokai"
                                        src={this.state.generatedJson}
                                        onEdit={edit => this.setState({ generatedJson: edit.updated_src })}
                                    />
                                </div>
                                <div className="skin-builder-preview-footer">
                                    <Button
                                        type="primary"
                                        loading={this.state.building}
                                        disabled={!!this.state.buildInfo}
                                        className="skin-builder-download-btn"
                                        onClick={this.confirmAndDownload}>
                                        <MdFileDownload size={16} style={{ marginRight: 6, verticalAlign: 'text-bottom' }} />
                                        {this.state.building ? 'Building APK…' : this.state.buildInfo ? 'Downloaded' : 'Download APK'}
                                    </Button>
                                    {this.state.buildInfo ? (
                                        <div className="skin-builder-build-info">
                                            <div><b>Version Code</b><span>{this.state.buildInfo.versionCode}</span></div>
                                            <div><b>Build Date</b><span>{formatBuildDate(this.state.buildInfo.buildDate)}</span></div>
                                            <div><b>MD5</b><span>{this.state.buildInfo.md5}</span></div>
                                            <div><b>Size</b><span>{formatSize(this.state.buildInfo.size)}</span></div>
                                            {(this.state.buildInfo.minio || []).map(asset => {
                                                var isApk = /\.apk$/i.test(asset.name);
                                                return (
                                                    <div key={asset.name}>
                                                        <b title={asset.name}>{isApk ? 'APK' : asset.name}</b>
                                                        <span>
                                                            {asset.ok
                                                                ? <a href={asset.url} target="_blank" rel="noopener noreferrer">{isApk ? 'Download from bucket' : 'View in bucket'}</a>
                                                                : 'Not archived'}
                                                        </span>
                                                    </div>
                                                );
                                            })}
                                        </div>
                                    ) : ''}
                                </div>
                            </div>
                        ) : (
                            <div className="skin-builder-empty">
                                <div className="skin-builder-empty-icon"><MdInbox size={22} /></div>
                                <p>Fill in the form and click "Make Skin" to preview the generated configuration here.</p>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        );
    }
}

export default withCookies(SkinBuilder);
